import React, { Component } from 'react'
import StyleSheet from 'styles'
import { connect } from 'react-redux'
import { ThirdPartyActions } from 'actionsets'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Dependent from 'containers/shared/Dependent'
import FormMixin from 'containers/shared/FormMixin'

export class Form extends FormMixin(Component){

  constructor(props){
    super(props)
    ThirdPartyActions.bindActions(this)
    this.onSaveRoute = '/third_parties'
  }

  get formObject(){
    return this.props.thirdParty
  }

  render = () => {
    const { Card, TextField, CardContent, CardActions, Button } = this
    return (
      <div style={{width: '100%'}}>
        <AppBar position="static">
          <Toolbar>
            <Typography variant='h6' className={styles.headline}>Edit third party: {this.props.thirdParty.name}</Typography>
          </Toolbar>
        </AppBar>
        <Card style={{maxWidth: 400}}>
          <CardContent>
            <TextField attribute='name' autoFocus={true}/>
          </CardContent>
          <CardActions className={styles.actions}>
            <Button onClick={() => this.props.history.push(this.onSaveRoute)} className={styles.save} >Cancel</Button>
            <Button onClick={this.save} className={styles.save} variant='contained' color='primary'>Save</Button>
          </CardActions>
        </Card>
      </div>
    )
  }

}

const styles = StyleSheet({
  headline: {
    flex: 1
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column'
  },
  actions: {
    display: 'flex',
    justifyContent: 'end',
    paddingLeft: 14,
    paddingRight: 14
  }
})

export default connect(({thirdParties}) => thirdParties)(Dependent({loader: true, wrapperClassName: styles.wrapper})(Form))